import { Requests } from "@app/api";
import {
	IAPOSTLogin,
	IAPOSTLogout,
	IAPOSTRegister,
	IAPOSTResetPassword,
	IAPUTAccessTokens,
	IAPUTLoginByAccessToken,
	IRPOSTLogin,
	IRPOSTLogout,
	IRPUTAccessTokens,
	IRPUTLoginByAccessToken,
	RPOSTLoginSchema,
} from "./validators";

const auth = {
	login: (data: IAPOSTLogin): Promise<IRPOSTLogin> =>
		Requests.send("POST", "/api/auth/login", data, null, {
			responseSchema: RPOSTLoginSchema,
		}),
	loginByToken: (
		data: IAPUTLoginByAccessToken
	): Promise<IRPUTLoginByAccessToken> =>
		Requests.send("POST", "/api/auth/login/:token", data, {
			headers: {
				access_token: undefined,
			},
		}),
	logout: (data: IAPOSTLogout): Promise<IRPOSTLogout> =>
		Requests.send("POST", "/api/auth/logout", data),
	updateAccessToken: (data: IAPUTAccessTokens): Promise<IRPUTAccessTokens> =>
		Requests.send("PUT", "/api/auth/access-tokens", data),
	getChatAccessToken: (): Promise<string> =>
		Requests.send("POST", "/api/auth/access-tokens/chat"),
	register: (data: IAPOSTRegister): Promise<IRPOSTLogin> =>
		Requests.send("POST", "/api/auth/register", data, null, {
			responseSchema: RPOSTLoginSchema,
		}),
	resetPassword: (data: IAPOSTResetPassword) =>
		Requests.send("POST", "/api/auth/reset-password", data),
};
export default auth;
